import { logLevels, isLogLevel } from './logSink';
import { consoleLogSink } from './consoleLogSink';
let currentLogSink = consoleLogSink;
export function setLogSink(logSink) {
    currentLogSink = logSink;
}
export const inactiveLogFn = () => { };
export function createLogger(name, rcLogLevel) {
    const rcLogLevelIndex = logLevels.indexOf(rcLogLevel);
    return logLevels.reduce((acc, functionName, index) => {
        acc[functionName] =
            index <= rcLogLevelIndex
                ? createLogFn(functionName, name)
                : inactiveLogFn;
        return acc;
    }, {});
}
function createLogFn(level, name) {
    return (...args) => {
        if (typeof args[0] === 'object') {
            const [data, msg, ...rest] = args;
            return currentLogSink({
                name,
                level,
                timestamp: Date.now(),
                data: Object.create(null, data),
                msg,
                args: rest,
            });
        }
        const [msg, ...rest] = args;
        return currentLogSink({
            name,
            level,
            timestamp: Date.now(),
            data: Object.create(null),
            msg,
            args: rest,
        });
    };
}
export function getLogLevel() {
    let logLevel;
    if (typeof localStorage !== 'undefined') {
        logLevel = localStorage.getItem('rcLogLevel');
    }
    else {
        logLevel = process.env.RC_LOG_LEVEL;
    }
    if (!logLevel) {
        if (process.env.NODE_ENV === 'development' ||
            process.env.NODE_ENV === 'test') {
            return 'warn';
        }
        return 'error';
    }
    if (isLogLevel(logLevel)) {
        return logLevel;
    }
    return 'error';
}
const rcLogLevel = getLogLevel();
const DEBUGGER_MAP = new Map();
export function getLogger(namespace) {
    const knownLogger = DEBUGGER_MAP.get(namespace);
    if (knownLogger) {
        return knownLogger;
    }
    const logger = createLogger(namespace, rcLogLevel);
    DEBUGGER_MAP.set(namespace, logger);
    return logger;
}
//# sourceMappingURL=logger.js.map